import createStyles from '@guestyci/foundation/createStyles';
import env from 'config/env';

const useStyles = createStyles(() => ({
  envLabel: {
    position: 'fixed',
    bottom: 10,
    left: 10,
    backgroundColor: 'orange',
    borderRadius: 5,
    border: '1px solid #000',
    color: 'white',
    padding: 5,
    textAlign: 'center',
  },
}));

function EnvIndicator() {
  const classes = useStyles();

  if (env === 'production') {
    return null;
  }

  return (
    <div className={classes.envLabel}>
      <div>{env}</div>
    </div>
  );
}

export default EnvIndicator;
